// `sizes` values for next/image for srcSet candidates

export const HERO_IMAGE_SIZES = '(max-width: 768px) 100vw, 586px';
export const HOMEPAGE_HERO_IMAGE_SIZES = '(max-width: 1024px) 100vw, 948px';
export const HOMEPAGE_CAROUSEL_IMAGE_SIZES = '1024px';
export const FEATURE_ICON_SIZES = '24px';
